import React from 'react';
import { motion } from 'framer-motion';
interface BookMockupProps {
  title: string;
  subtitle?: string;
  className?: string;
  variant?: 'main' | 'bonus1' | 'bonus2' | 'bonus3';
  size?: 'sm' | 'md' | 'lg';
}
export function BookMockup({
  title,
  subtitle,
  className = '',
  variant = 'main',
  size = 'md'
}: BookMockupProps) {
  const sizeClasses = {
    sm: 'w-32 h-44',
    md: 'w-48 h-64',
    lg: 'w-72 h-96'
  };
  const titleSizes = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl'
  };
  const bgClasses = {
    main: '',
    bonus1: 'bg-sand text-charcoal',
    bonus2: 'bg-mauve text-cream',
    bonus3: 'bg-terracotta text-cream'
  };
  const bgImages: Record<string, string> = {
    main: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?auto=format&fit=crop&q=80',
    bonus1: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&q=80',
    bonus2: 'https://images.unsplash.com/photo-1615486171448-4af6820fb216?auto=format&fit=crop&q=80',
    bonus3: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&q=80'
  };
  const coverUrls: Record<string, string> = {
    main: 'https://cdn.magicpatterns.com/uploads/nwHGsPdHdyygPFb8ZcJSBg/Gemini_Generated_Image_cydegncydegncyde.png',
    bonus1: 'https://cdn.magicpatterns.com/uploads/w6Mdx19iDF5gT5ruwL2m4Q/Gemini_Generated_Image_9llkml9llkml9llk12.png',
    bonus2: 'https://cdn.magicpatterns.com/uploads/hPz73pLa8HoGU2moqTHqHx/Gemini_Generated_Image_bg7c7xbg7c7xbg7c11.png',
    bonus3: 'https://cdn.magicpatterns.com/uploads/hyjfJxeY6ryjLR42S4dm6Z/Gemini_Generated_Image_w8160zw8160zw816_(3).png'
  };
  const hasCover = variant in coverUrls;
  const bgImage = bgImages[variant];
  return <motion.div className={`relative rounded-r-lg rounded-l-sm shadow-2xl overflow-hidden flex flex-col items-center justify-center text-center border border-white/20 ${sizeClasses[size]} ${!hasCover ? bgClasses[variant] + ' p-3' : ''} ${className}`} style={{
    transformStyle: 'preserve-3d',
    transform: 'perspective(1000px) rotateY(-15deg) rotateX(5deg)',
    boxShadow: '-15px 20px 30px rgba(0,0,0,0.15), inset 4px 0 10px rgba(255,255,255,0.2)'
  }} initial={{
    opacity: 0,
    y: 20,
    rotateY: -25
  }} whileInView={{
    opacity: 1,
    y: 0,
    rotateY: -15
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} data-id="element-78">
      {/* Book spine shadow */}
      <div className="absolute left-0 top-0 bottom-0 w-6 bg-gradient-to-r from-black/30 to-transparent z-10" data-id="element-79" />
      <div className="absolute left-1 top-0 bottom-0 w-[1px] bg-white/30 z-10" data-id="element-80" />

      {hasCover ? <img src={coverUrls[variant]} alt={title} className="absolute inset-0 w-full h-full object-cover z-0" style={{
      objectPosition: '50% 25%'
    }} data-id="element-81" /> : <>
          {/* Subtle background texture for bonus books */}
          <div className="absolute inset-0 bg-cover bg-center opacity-20 mix-blend-overlay" style={{
        backgroundImage: `url(${bgImage})`
      }} data-id="element-82" />

          <div className="relative z-20 flex flex-col items-center h-full justify-between py-4" data-id="element-83">
            <div className="space-y-2" data-id="element-84">
              <h3 className={`font-serif leading-tight ${titleSizes[size]}`} data-id="element-85">
                {title}
              </h3>
              {subtitle && <p className={`text-xs font-sans opacity-80 max-w-[80%] mx-auto`} data-id="element-86">
                  {subtitle}
                </p>}
            </div>
          </div>
        </>}
    </motion.div>;
}